export default __webpack_public_path__ + "static/media/Wired.4baa3a95.svg";